import { DropdownPopperProps } from '@patternfly/react-core';

export const DEFAULT_POPPER_PROPS: DropdownPopperProps = {
  position: 'end',
  preventOverflow: true,
};
